val formatter = js("new Intl.NumberFormat('en-US', {style: 'currency',currency: 'USD',});")

actual fun formatDecimalToCurrency(decimal: Double): String {
    return formatter.format(decimal) as String
}